import { render, staticRenderFns } from "./RM_1D_positioning-modal.vue?vue&type=template&id=396a51ec&scoped=true"
import script from "./RM_1D_positioning-modal.vue?vue&type=script&lang=js"
export * from "./RM_1D_positioning-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396a51ec",
  null
  
)

export default component.exports